import { Injectable } from "@angular/core";
import { PartnerResolver, PartnerResolverType } from "../models/partner-resolver";
import { JsonHttpService } from "../../shared/http/json-http.service";
import { HttpParams } from "@angular/common/http";


@Injectable({
    providedIn: 'root'
})
export class PartnerResolverService {

    constructor(private httpService: JsonHttpService) { }

    getPartnerResolvers(type: PartnerResolverType): Promise<PartnerResolver[]> {
        const options = { params: new HttpParams().set('partnerResolverType', type.toString()) };
        return this.httpService.get('api/partners/resolver/get-resolvers', options).toPromise();
    }

    savePartnerResolvers(partnerResolver: PartnerResolver[]): Promise<void> {
        const saveObject = {
            PartnerResolvers: partnerResolver
        };
        return this.httpService.post('/api/partners/resolver/save-resolvers', saveObject).toPromise();
    }
}
